export const sharedLoanAppInfoBuilderForMilli = (sharedLoanAppInfo) => {
  return (
    sharedLoanAppInfo && {
      adviserId: sharedLoanAppInfo.AdviserId,
      loanApplicationId: sharedLoanAppInfo.LoanApplicationId,
      clientId: sharedLoanAppInfo.ClientId,
    }
  );
};
